"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileUploadDropAreaContainerStyleConfig = void 0;
var react_1 = require("@emotion/react");
var variables_1 = require("../../../../style/variables");
var disabledContainerStyle = {
    cursor: 'not-allowed',
    background: "var(" + variables_1.RootColor.Gray.LIGHT_6 + ")",
    borderColor: "var(" + variables_1.RootColor.Gray.LIGHT_3 + ")",
    color: "var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
};
var fileUploadDropAreaContainerStyles = {
    base: {
        container: {
            default: {
                background: "var(" + variables_1.RootColor.White + ")",
                border: "1px solid var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
                borderRadius: '6px',
                color: "var(" + variables_1.RootColor.Gray.DEFAULT + ")",
                padding: '16px 24px',
            },
            hovered: {
                background: "var(" + variables_1.ThemeColor.Primary.LIGHT_6 + ")",
                borderColor: "var(" + variables_1.ThemeColor.Primary.LIGHT_1 + ")",
                color: "var(" + variables_1.ThemeColor.Primary.LIGHT_1 + ")",
            },
        },
    },
    disabled: {
        container: {
            default: __assign({}, disabledContainerStyle),
            hovered: __assign({}, disabledContainerStyle),
        },
    },
};
exports.fileUploadDropAreaContainerStyleConfig = {
    container: react_1.css(__assign(__assign({}, fileUploadDropAreaContainerStyles.base.container.default), { ':hover': __assign({}, fileUploadDropAreaContainerStyles.base.container.hovered) })),
    disabledContainer: react_1.css(__assign(__assign({}, fileUploadDropAreaContainerStyles.disabled.container.default), { ':hover': __assign({}, fileUploadDropAreaContainerStyles.disabled.container.hovered) })),
};
